//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  name: "process-content",
  props: ['post'],
  computed: { ...mapState(['processContentLoading']) }
}
